import Constants, { UPS_INDICATORS } from '../../constants/Constants';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import Address from '../../domain/entities/Address';
import AddressRepository from '../../repositories/AddressRepository';
import ShippingRepository from '../../repositories/ShippingRepository';
import TransactionRepository from '../../repositories/TransactionRepository';
import { dispatchOpenTracking, dispatchSuggestionTracking } from '../../repositories/AnalyticsRepository';

class UpsSetValidationsUseCase {
  private addressRepository: AddressRepository;

  private transactionRepository: TransactionRepository;

  private shippingRepository: ShippingRepository;

  private address: Address;

  constructor(address: Address) {
    this.address = address;
    this.addressRepository = diContainer.get(serviceNames.addressRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
  }

  public execute = async (): Promise<void> => {
    const response = await this.addressRepository.getAddressSuggestions(this.address);
    const { suggestions, indicators } = response;

    dispatchOpenTracking();
    this.shippingRepository.setUpsIndicators(indicators);

    if (indicators?.some(ind => ind.key === UPS_INDICATORS.NO_CANDIDATES) && suggestions?.length === 0) {
      dispatchSuggestionTracking(indicators[0].key);
      this.shippingRepository.setUpsAddress(this.address.attributes, []);
      throw new Error(Constants.UPS_VALIDATION);
    }

    if (indicators?.some(ind => ind.key === UPS_INDICATORS.AMBIGUOUS) && suggestions?.length > 1) {
      dispatchSuggestionTracking(indicators[0].key);
      this.shippingRepository.setUpsAddress(this.address.attributes, suggestions.map(s => s.attributes));
      throw new Error(Constants.UPS_VALIDATION);
    }

    if (suggestions?.length === 1) {
      dispatchSuggestionTracking('validAddressIndicator');
      const upsAddress = suggestions[0];
      this.shippingRepository.setUpsAddress(this.address.attributes, [upsAddress.attributes]);
      throw new Error(Constants.UPS_VALIDATION);
    }
  };
}

export default UpsSetValidationsUseCase;
